import React from 'react';
import { FaFacebookF, FaLinkedinIn, FaYoutube, FaInstagram } from "react-icons/fa";
import logo from '../../assets/INVESTYCOONS LOGO.png';
import { FaTwitter } from "react-icons/fa";


const Footer = () => {
    return (
        <footer className="bg-white dark:bg-gray-900">
            <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
                <div className="md:flex md:justify-between">
                    <div className="mb-6 md:mb-0">
                        <a href="/" className="flex items-center">
                            <img src={logo} className="h-14 me-3" alt="InvestyCoons Logo" />
                        </a>
                    </div>

                    <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Other Links</h2>
                            <ul className="text-gray-500 dark:text-gray-400 font-medium">
                                <li className="mb-4"><a href="/ace-acreville" className="hover:underline">Ace Acreville</a></li>
                                <li className="mb-4"><a href="/lake-view-farms" className="hover:underline">Lake View Farmhouse</a></li>
                                <li className="mb-4"><a href="/ats-province-d-olympia" className="hover:underline">ATS Province D Olympia</a></li>
                            </ul>
                        </div>

                        {/* Social Media Links */}
                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Follow us</h2>
                            <ul className="text-gray-500 dark:text-gray-400 font-medium">
                                <li className="mb-4"><a href="https://www.instagram.com/investycoons/" target="_blank" className="hover:underline">Instagram</a></li>
                                <li className="mb-4"><a href="https://www.facebook.com/investycoons/" target="_blank" className="hover:underline">Facebook</a></li>
                                <li className="mb-4"><a href="https://x.com/investycoons" target="_blank" className="hover:underline">Twitter</a></li>
                                <li className="mb-4"><a href="https://www.linkedin.com/company/investycoons/" target="_blank" className="hover:underline">LinkedIn</a></li>
                                <li className="mb-4"><a href="https://www.youtube.com/@investycoons" target="_blank" className="hover:underline">YouTube</a></li>
                            </ul>
                        </div>
                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Legal</h2>
                            <ul className="text-gray-500 dark:text-gray-400 font-medium">
                                <li className="mb-4"><a href="/terms" className="hover:underline">T & C</a></li>
                                <li className="mb-4"><a href="/disclaimer" className="hover:underline">Disclaimer</a></li>
                                <li className="mb-4"><a href="/privacy-policy" className="hover:underline">Privacy Policy</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
                <div className="flex flex-wrap justify-between items-center px-4 sm:px-16">
                    <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
                        © 2025 <a href="/" className="hover:underline">InvestyCoons™</a>. All Rights Reserved.
                    </span>

                    <div className="flex mt-4 sm:mt-0 space-x-5">
                        <a href="https://www.instagram.com/investycoons/" target="_blank" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                            <FaInstagram size={20} />
                        </a>
                        <a href="https://www.facebook.com/investycoons/" target="_blank" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                            <FaFacebookF size={20} />
                        </a>
                        <a href="https://x.com/investycoons" target="_blank" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                            <FaTwitter size={20} />
                        </a>
                        <a href="https://www.linkedin.com/company/investycoons/" target="_blank" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                            <FaLinkedinIn size={20} />
                        </a>
                        <a href="https://www.youtube.com/@investycoons" target="_blank" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                            <FaYoutube size={20} />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;